import {
    ADD_ITEMS_TO_QUEUE,
    CLEAR_QUEUE_PROGRESS,
    REMOVE_ITEMS_FROM_QUEUE,
    UPDATE_QUEUE_PROGRESS,
    UPDATE_SHOW_DOWNLOAD_MANAGER
} from '../action/types';

const initialState = {
    queue: [],
    showDownloadManager: true
};

export default function (state = initialState, action) {
    const {type, payload} = action;
    let newQueue = [...state.queue];
    switch (type) {
        case REMOVE_ITEMS_FROM_QUEUE:
            let newestQueueAfterRemove = [];
            if (payload && payload.itemsToRemove && payload.itemsToRemove.length) {
                newQueue.forEach(elementInQueue => {
                    const isToRemove = payload.itemsToRemove.findIndex(el => el.url === elementInQueue.url) > -1;
                    // lo rimuovo dalla coda (se isToRemove)
                    if (!isToRemove) {
                        newestQueueAfterRemove.push(elementInQueue);
                    }
                });
            }
            return {
                ...state,
                queue: newestQueueAfterRemove,
                showDownloadManager: !payload.closeManager
            }
        case CLEAR_QUEUE_PROGRESS:
            // la clear rimuove DIRETTAMENTE solo i pending e i completati (per tutti gli altri si aspetta venga cancellata la xhr tramite abort controller)
            let newestQueueAfterClear = [];
            if (payload && payload.itemsToClear && payload.itemsToClear.length) {
                newQueue.forEach(elementInQueue => {
                    const isToClear = payload.itemsToClear.findIndex(el => el.url === elementInQueue.url) > -1;
                    // lo rimuovo dalla coda (se isToClear) se pending o completato
                    if (!isToClear || (!elementInQueue.pending && elementInQueue.progress !== 1)) {
                        newestQueueAfterClear.push(elementInQueue);
                    }
                });
            } else {
                newestQueueAfterClear = newQueue;
            }
            // else {
            //     newQueue.forEach(elementInQueue => {
            //         // lo rimuovo dalla coda se pending o completato
            //         if (!elementInQueue.pending && elementInQueue.progress !== 1) {
            //             newestQueueAfterClear.push(elementInQueue);
            //         }
            //     });
            // }
            return {
                ...state,
                queue: newestQueueAfterClear,
                showDownloadManager: !payload.closeManager
            }
        case ADD_ITEMS_TO_QUEUE:
            newQueue = checkQueueItems(newQueue, payload);
            // aggiungo alla coda elementi solo se non esistevano
            return {
                ...state,
                queue: newQueue,
                showDownloadManager: true
            }
        case UPDATE_QUEUE_PROGRESS:
            payload.forEach(element => {
                let elemToUpdateProgressIndex = state.queue.findIndex(elem => elem.url === element.url);
                if (elemToUpdateProgressIndex >= 0) {
                    newQueue[elemToUpdateProgressIndex].progress = element.progress;
                    newQueue[elemToUpdateProgressIndex].status = element.status;
                    newQueue[elemToUpdateProgressIndex].statusText = element.statusText;
                    if (element.pending) {
                        newQueue[elemToUpdateProgressIndex].pending = element.pending;
                    }
                    if (element.filename) {
                        newQueue[elemToUpdateProgressIndex].filename = element.filename;
                    }
                    if (element.actualFilename) {
                        newQueue[elemToUpdateProgressIndex].actualFilename = element.actualFilename;
                    }
                    if (element.xhr) {
                        newQueue[elemToUpdateProgressIndex].xhr = element.xhr;
                    }
                    if (element.abortController) {
                        newQueue[elemToUpdateProgressIndex].abortController = element.abortController;
                    }
                } else {
                    console.log("Cannot update item because it couldn't be find in the queue",element);
                    // l'elemento nella queue non c'è - per consistenza se ha una xhr attiva devo fare l'abort
                    if (element.xhr && element.abortController) {
                        element.abortController.abort('Aborted because missing in queue');
                    }
                }
            });
            return {
                ...state,
                queue: newQueue
            }
        case UPDATE_SHOW_DOWNLOAD_MANAGER:
            return {
                ...state,
                showDownloadManager: payload,
            }
        default:
            return state
    }
};

const checkQueueItems = (queue, queueItems) => {
    let newQueue = queue;
    let newItems = [];
    let queueCounter = newQueue.length;
    queueItems.forEach(queueItem => {
       const alreadyInQueueIndex = queue.findIndex(elem => elem.url === queueItem.url);
       if (alreadyInQueueIndex < 0) {
           if (queueItem.hasOwnProperty('index')) {
               // lo aggiungo nella sua posizione precedente
               newQueue = [
                   ...newQueue.slice(0, queueItem.index),
                   queueItem,
                   ...newQueue.slice(queueItem.index)
               ];
           } else {
               queueItem['index'] = queueCounter++;
               // lo segno come da pushare
               newItems.push(queueItem); // lo dovrò aggiungere
           }
       }
    });
    // li aggiungo
    newQueue = newQueue.concat(newItems);
    // pulisco gli index
    let counter = 0;
    return newQueue.map(queueIndex => {
        return {...queueIndex, index: counter++};
    });
}
